import { alpha } from '@mui/material/styles'
import { r4r } from 'styles/theme'
import { BadgeColors } from 'components/Helpdesk/helpdesk.utils'
import {
  CONTRACT_ACTIVE_GROUP,
  CONTRACT_BOOKING_GROUP,
  CONTRACT_PENDING_SIGNATURE_GROUP
} from 'services/contracts/contracts.consts'
import dayjs from 'dayjs'

// Visual helpers for the Leases section ("Panel Klienta 3.0" redesign).

export interface LeaseStatusMeta {
  i18n: { id: string; defaultMessage: string }
  colors: BadgeColors
}

// Lease contract status → badge label + colors.
export const getLeaseStatusMeta = (leaseStatus: number): LeaseStatusMeta => {
  if (CONTRACT_ACTIVE_GROUP.includes(leaseStatus)) {
    return {
      i18n: { id: 'leaseStatus.active', defaultMessage: 'Aktywna' },
      colors: { backgroundColor: alpha(r4r.green, 0.12), color: r4r.green }
    }
  }

  if (
    CONTRACT_BOOKING_GROUP.includes(leaseStatus) ||
    CONTRACT_PENDING_SIGNATURE_GROUP.includes(leaseStatus)
  ) {
    return {
      i18n: { id: 'leaseStatus.signature', defaultMessage: 'Do podpisu' },
      colors: { backgroundColor: alpha(r4r.yellow, 0.3), color: r4r.yellowDark }
    }
  }

  return {
    i18n: { id: 'leaseStatus.ended', defaultMessage: 'Zakończona' },
    colors: { backgroundColor: r4r.greyLight, color: r4r.grey }
  }
}

export const formatMoney = (value?: string | number | null, currency = '') => {
  const amount = parseFloat(String(value ?? ''))
  const safe = Number.isFinite(amount) ? amount : 0
  const [integer, fraction] = safe.toFixed(2).split('.')
  const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  return `${grouped},${fraction}${currency ? ` ${currency}` : ''}`
}

export const flattenScheduleGroups = <T,>(grouped: Record<string, T[]>): T[] =>
  Object.values(grouped).flat()

export const getDocumentDueDate = (document: any) => {
  if (document.dateOfIssue) {
    return dayjs(document.dateOfIssue)
  }

  if (document.invoiceDate) {
    return dayjs(document.invoiceDate)
  }

  if (document.displayDate) {
    return dayjs(document.displayDate)
  }

  return dayjs(NaN)
}

export const getDocumentAmount = (document: {
  amount?: string
  finalGrossAmount?: string
  totalAmountGross?: string
}) => document.amount || document.finalGrossAmount || document.totalAmountGross || '0'

export const getDocumentPaidAmount = (document: { paidAmount?: string; paymentAmount?: string }) =>
  document.paidAmount || document.paymentAmount || '0'
